import { MoveStruct } from "../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
const Bag = new MoveStruct({
	name: `0x2::bag::Bag`,
	fields: {
		id: bcs.Address,
		size: bcs.u64()
	}
});
//#endregion
export { Bag };

//# sourceMappingURL=bag.mjs.map